import { render, staticRenderFns } from "./menu-inventory.vue?vue&type=template&id=6e45cf5a&"
import script from "./menu-inventory.vue?vue&type=script&lang=js&"
export * from "./menu-inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports